// One activity-log note, editable in place.
//
// The permission to edit these has existed in the database for a while, and so
// has an edit screen under Settings → Activity Logs. What was missing was any
// way to do it where people actually read the log: a client's own Activity Log
// tab, and a lead's. A coordinator who typed the wrong thing had to know that a
// separate admin screen existed, so in practice the note just stayed wrong.
//
// Only the note is editable. The status change beside it is the record of what
// happened and is not ours to rewrite; correcting that means logging the real
// change. Every edit is stamped with who made it and when, and shown.
import { format } from 'date-fns';
import InlineNote from './InlineNote';
import { updateActivityLog } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';

// The three roles the activity_log update policy already trusts.
export const canEditNotes = (role) => ['admin', 'manager', 'coordinator'].includes(role);

export default function ActivityNote({ item, onSaved, size = 13 }) {
  const { profile } = useAuth();

  const save = async (text) => {
    const { error } = await updateActivityLog(item.id, {
      notes: text || null,
      updated_by_id: profile?.id,
      updated_by_name: profile?.full_name,
    });
    if (error) throw new Error(error.message);
    onSaved && onSaved();
  };

  return (
    <InlineNote
      value={item.notes}
      onSave={save}
      canEdit={canEditNotes(profile?.role)}
      size={size}
      footer={item.updated_at ? (
        <div style={{ fontSize: 10.5, color: 'var(--text3)', marginTop: 2 }}>
          Edited by {item.updated_by_name || 'someone'} · {format(new Date(item.updated_at), 'MMM d, yyyy h:mm a')}
        </div>
      ) : null}
    />
  );
}
